import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Azul predeterminado
    },
    secondary: {
      main: '#dc004e', // Rojo predeterminado
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
});

export default theme;
